import { normalize } from 'normalizr';
import { camelizeKeys } from 'humps';
import Logger from 'observability/Logger';

const LOG = new Logger('normalizedApiResponse');

/**
 * Normalizes an API response by camelizing it and applying a normalizr schema
 *
 * @param  {Object} data - API response
 * @param  {Schema} schema - normalizr schema to apply to the data
 * @return {Object} normalized API response
 */
const normalizeApiResponse = (data, schema) => {
    if (__DEVELOPMENT__) {
        // This is a noisy log, so only log in local development.
        // It can be helpful to see the raw data and schema when debugging normalization issues.
        LOG.info('normalize Api Response', { data, schema });
    }
    return normalize(camelizeKeys(data), schema);
};

export default normalizeApiResponse;
